import { render, staticRenderFns } from "./mobile_navigation.vue?vue&type=template&id=24ab6bc6&scoped=true&"
import script from "./mobile_navigation.vue?vue&type=script&lang=js&"
export * from "./mobile_navigation.vue?vue&type=script&lang=js&"
import style0 from "./mobile_navigation.vue?vue&type=style&index=0&id=24ab6bc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ab6bc6",
  null
  
)

export default component.exports